<template>
    <div class="bg-navy
                text-white
                font-book
                rounded-md
                shadow
                p-6
                divide-y
                divide-white
                divide-opacity-10">
        <div class="pb-4">
            <h5 class="text-lg
                       uppercase
                       mb-2">
                Your Customized Service
            </h5>
        </div>
        <div class="py-4">
            <h6 class="mb-2">
                Total Monthly Charges
            </h6>
            <div class="bg-navy-dark
                        p-4 pb-2
                        text-sm
                        divide-y divide-white divide-opacity-10
                        flex
                        flex-col
                        gap-2">
                <div class="animate-pulse">
                    <div class="h-4 w-20 mb-2 mt-0.5 bg-navy-loading rounded-full"></div>
                    <div class="h-4 ml-2 mb-3 bg-navy-loading rounded-full"></div>
                    <div class="h-4 ml-2 mb-3 bg-navy-loading rounded-full"></div>
                    <div class="h-4 ml-2 mb-3 bg-navy-loading rounded-full"></div>
                    <div class="h-4 w-24 ml-auto mb-0.5 bg-navy-loading rounded-full"></div>
                </div>
                <div class="animate-pulse">
                    <div class="h-4 w-14 mb-2 mt-3.5 bg-navy-loading rounded-full"></div>
                    <div class="h-4 ml-2 mb-2 bg-navy-loading rounded-full"></div>
                </div>
                <div class="pt-3 animate-pulse">
                    <div class="h-6 mt-0.5 mb-0.5 bg-navy-loading rounded-full"></div>
                </div>
            </div>
        </div>
        <div class="py-4">
            <div class="flex-spread-h
                        mb-2">
                <h6>
                    Your First Bill
                </h6>
            </div>
            <div class="bg-navy-dark
                        p-4 pb-2
                        text-sm
                        divide-y divide-white divide-opacity-10
                        gap-2">
                <div class="animate-pulse">
                    <div class="h-4 mb-2.5 mt-1 bg-navy-loading rounded-full"></div>
                    <div class="h-4 w-32 mb-1.5 bg-navy-loading rounded-full"></div>
                    <div class="h-4 ml-2 mb-2 bg-navy-loading rounded-full"></div>
                </div>
                <div class="pt-3 animate-pulse">
                    <div class="h-6 mb-0.5 bg-navy-loading rounded-full"></div>
                </div>
            </div>
        </div>
        <div class="py-4">
            <div class="flex
                        justify-end">
                <div class="text-xl">
                    <span class="font-book">After that you'll pay:</span>
                </div>
                <div class="h-7 w-18 ml-1.5 mr-1 mt-1 bg-navy-loading rounded-full animate-pulse"></div>
                <div class="text-sm mb-1 mt-auto">
                    /mo
                </div>
            </div>
            <div class="mb-2 text-right">
                <span class="text-sm">
                    Price guaranteed for the next...
                </span>
                <IconCircleInfo class="inline text-sm -mt-1" />
            </div>
            <div class="uppercase font-bold text-right">
              No contract. Cancel anytime.
            </div>
            <div class="text-sm
                        flex
                        justify-end">
                <div>
                    Includes $10 AutoPay & EcoSave Discount
                    <IconCircleInfo class="inline -mt-1" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import IconCircleInfo from "@/atoms/icons/IconCircleInfo"

    export default {
        name: 'AppCartLoading',
        components: {
            IconCircleInfo,
        },
        props: {
            cartData: {
                type: Object,
                required: true,
            },
        },
        computed: {
            ...mapGetters('Buyflow', [
                'sectionStatus',
            ]),
        }
    }
</script>
